import getFullAddressString from 'src/util/address';

/**
 * Filters properties by title and address matching a search term (case-insensitive).
 * @param {Array} propertyList - List of property objects
 * @param {string} searchTerm - The search term to filter by
 * @returns {Array} Filtered list of properties
 */
export default function getFilteredProperties(propertyList, searchTerm) {
  if (!searchTerm) return propertyList;

  const searchTermLower = searchTerm.toLowerCase();
  return propertyList.filter((p) => {
    const titleMatch = p.title?.toLowerCase().includes(searchTermLower) ?? false;
    const addressString = getFullAddressString(p.address) ?? '';
    const addressMatch = addressString.toLowerCase().includes(searchTermLower);
    return titleMatch || addressMatch;
  });
}
